export class CardTableExpandableHeader {
	ID = "";
	Width: number;
}
